import { onAuthStateChanged, User } from "firebase/auth";
import { auth } from "./firebase.js";
import { useEffect, useState } from "react";
import { adminExists } from "./firestore/functions.tsx";
import { FC } from "react";
import { signOut } from "./auth/functions.tsx";
import { LoadingPage } from "../widgets/small-widgets.jsx";

type AuthProviderLogingProps = {
    children: React.ReactElement;
    exemptHrefs: string[];
}

const AuthProviderLoging: FC<AuthProviderLogingProps> = ({ children, exemptHrefs }) => {
    const [user, setUser] = useState<User | null | undefined>(null);

    useEffect(() => {
        if (!exemptHrefs.includes(window.location.pathname)) {
            onAuthStateChanged(auth, async (user) => {
                if (user) {
                    const isRegistered = await adminExists(user.uid);
                    if (isRegistered) {
                        setUser(user);
                    } else {
                        await signOut();
                    }
                } else {
                    await signOut();
                }
            });
        } else {
            setUser(undefined);
        }
    }, []);

    if (user !== null) {
        return <div>{children}</div>;
    }

    return <LoadingPage/>;
}

export default AuthProviderLoging;